import React from 'react';
import withIcon from '../utilities/withIcon';

const IconStar = () => {
  return (
    <g>
      <path d="m5.738 5.528-4.999.008-.103.007c-.634.085-.878.933-.34 1.345l4.06 3.105-1.548 5.028-.023.094c-.12.65.623 1.149 1.17.732L8 12.772l4.044 3.075.08.053c.564.332 1.272-.215 1.068-.879l-1.55-5.028 4.062-3.105.078-.069c.457-.454.152-1.282-.521-1.283l-5-.008L8.704.525a.735.735 0 0 0-1.408 0L5.738 5.528zm2.261-2.285 1.016 3.262.04.1a.738.738 0 0 0 .664.425l3.334.005-2.714 2.077-.078.069a.76.76 0 0 0-.183.756l1.02 3.314-2.656-2.018-.09-.06a.729.729 0 0 0-.794.06L4.9 13.25l1.022-3.314.024-.102a.757.757 0 0 0-.285-.723L2.946 7.035l3.335-.005a.74.74 0 0 0 .704-.525l1.014-3.262z" />
    </g>
  );
};

export default withIcon(IconStar);
